/* eslint-disable */
import { soapPost } from '../../../ajaxSoap'
import { bizTypeMap } from '../../../bizTypeMapping'

export const queryPickingExceList = async (query) => {
    var ret = null
    await soapPost(bizTypeMap.queryPickingExceList, query)
      .done(function (data) {
        ret = data
      })
    return ret
  }

export const confirPickPass = async (param) => {
    var ret = null
    await soapPost(bizTypeMap.confirPickPass, param)
      .done(function (data) {
        console.log(data)
        ret = data
      })
    return ret
  }
export const printQuery = async (param) => {
    var ret = null
    await soapPost(bizTypeMap.printQuery, param)
      .done(function (data) {
        console.log(data)
        ret = data
      })
    return ret
  }

//b2b打印根据订单号查询所有已复核数据信息
export const queryToBReviewPack = async (newcrete) => {
  console.info("parameters:"+ newcrete);
  let ret
  await soapPost(bizTypeMap.queryToBReviewPack,newcrete)
    .done(function (data) {
      ret = data
    })
  return ret
}
